import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useDetectClickOutside } from "react-detect-click-outside";
import { useDispatch } from "react-redux";
import { _axios } from "../../api";
import SettingFormItems, {
  SettingItem,
  SettingItems,
} from "../../components/SettingFormItems";
import { adminTokenCookieName } from "../../utils/constants";
import { updateWidgetItem } from "../../utils/requests";
import { showToastV2 } from "../WidgetBuilder";
import { findWidgetByName } from "../../utils/findWidgetByName";

type SettingsNames =
  | "phone"
  | "email"
  // | "facebook"
  // | "instagram"
  // | "youtube"
  // | "twitter"
  | "footerTitle1"
  | "footerTitle2"
  | "footerTitle3"
  | "footerTitle4";

  const footerSettings: SettingItem<SettingsNames>[] = [
    {
        name: "Email",
        key: "email",
        type: "text",
    },
    {
        name: "Phone",
        key: "phone",
        type: "text",
    },
    // {
    //     name: "Facebook",
    //     key: "facebook",
    //     type: "text",
    // },
    // {
    //     name: "Instagram",
    //     key: "instagram",
    //     type: "text",
    // },
    // {
    //     name: "Youtube",
    //     key: "youtube",
    //     type: "text",
    // },
    // {
    //     name: "Twitter",
    //     key: "twitter",
    //     type: "text",
    // },
];

const footerMenuSettings: SettingItem<SettingsNames>[] = [
  {
    name: "Menu 1 Title",
    key: "footerTitle1",
    placeholder: "Company",
    type: "text",
  },
  {
    name: "Menu 2 Title",
    key: "footerTitle2",
    placeholder: "Help Center",
    type: "text",
  },
  {
    name: "Menu 3 Title",
    key: "footerTitle3",
    placeholder: "Terms & Condition",
    type: "text",
  },
  {
    name: "Menu 4 Title",
    key: "footerTitle4",
    placeholder: "Stay In touch",
    type: "text",
  },
];



const FooterMenu = () => {
  const dispatch = useDispatch();

  const [settings, setSettings] = useState<SettingItems<SettingsNames>>({});



  const [menues, setMenues] = useState<any[]>([]);
  const [menu1, setMenu1] = useState<any>();
  const [menu2, setMenu2] = useState<any>();
  const [menu3, setMenu3] = useState<any>();
  const [menu4, setMenu4] = useState<any>();


  const [menuText, setMenuText] = useState<string>("");
  const [showMenu, setShowMenu] = useState<
    "menu1" | "menu2" | "menu3" | "menu4"
  >();
  const [menuPagination, setMenuPagination] = useState<{
    total: number;
    lastPage: number;
    currentPage: number;
  }>({
    total: 0,
    lastPage: 1,
    currentPage: 1,
  });

  const [themeSettingsW, setThemeSettingsW] = useState<any | null>(null);

  const menuSuggestion = useDetectClickOutside({
    onTriggered: () => setShowMenu(undefined),
  });

  useEffect(() => {
    findWidgetByName("Theme Settings").then((res) => {
      setThemeSettingsW(res);

      setSettings({
        phone: res?.settings?.footerSettings?.phone || "",
        email: res?.settings?.footerSettings?.email || "",
        // facebook: res?.settings?.footerSettings?.facebook || "",
        // instagram: res?.settings?.footerSettings?.instagram || "",
        // youtube: res?.settings?.footerSettings?.youtube || "",
        // twitter: res?.settings?.footerSettings?.twitter || "",
        footerTitle1: res?.settings?.footerSettings?.footerTitle1 || "",
        footerTitle2: res?.settings?.footerSettings?.footerTitle2 || "",
        footerTitle3: res?.settings?.footerSettings?.footerTitle3 || "",
        footerTitle4: res?.settings?.footerSettings?.footerTitle4 || "",
      });

      if (res?.settings?.footerSettings?.menu1)
        setMenu1({
          name: res?.settings?.footerSettings?.menu1 || "",
          slug: res?.settings?.footerSettings?.menu1 || "",
        });

      if (res?.settings?.footerSettings?.menu2)
        setMenu2({
          name: res?.settings?.footerSettings?.menu2 || "",
          slug: res?.settings?.footerSettings?.menu2 || "",
        });

      if (res?.settings?.footerSettings?.menu3)
        setMenu3({
          name: res?.settings?.footerSettings?.menu3 || "",
          slug: res?.settings?.footerSettings?.menu3 || "",
        });
      if (res?.settings?.footerSettings?.menu4)
        setMenu4({
          name: res?.settings?.footerSettings?.menu4 || "",
          slug: res?.settings?.footerSettings?.menu4 || "",
        });

     
    });

    _axios
      .get(process.env.REACT_APP_BUILDER_URL + `menu`, {
        headers: {
          Authorization: `Bearer ${Cookies.get(adminTokenCookieName)}`,
        },
      })
      .then((res) => {
        setMenues(res.data);
      });
  }, []);

  const handlePublish = () => {
    const footerSettings = {
      ...themeSettingsW.settings?.footerSettings,
      ...settings,
      menu1: createSlug(menu1?.name),
      menu2: createSlug(menu2?.name),
      menu3: createSlug(menu3?.name),
      menu4: createSlug(menu4?.name),
    };

    updateWidgetItem({
      ...themeSettingsW,
      status: "published",
      active: true,
      settings: {
        ...themeSettingsW.settings,
        footerSettings,
      },
    })
      .then((res) => {
        showToastV2("Footer updated successfully");
      })
      .catch(() => {
        showToastV2("Footer update failed!", "error");
      });
  };

  // const handleFooterNavItemsSort = () => {
  //     dispatch(
  //         setGlobalSortPopupElement(
  //             <PopupWrapper
  //                 className="!z-[10000]"
  //                 onClose={() => {
  //                     dispatch(setGlobalSortPopupElement(null));
  //                 }}
  //             >
  //                 <SortList
  //                     data={footerBottomItems}
  //                     renderElement={(item) => (
  //                         <p className="select-none">{item.name}</p>
  //                     )}
  //                     updateData={(data) => {
  //                         setFooterBottomItems(data);

  //                         setSelectedFooterNavs(prev => data.filter(item => prev.includes(item.key)).map(i => i.key))

  //                         dispatch(setGlobalSortPopupElement(null));
  //                     }}
  //                 />
  //             </PopupWrapper>
  //         )
  //     );
  // };

  const handleToDraft = () => {
    console.log("Safe to draft");
  };

  const handleMenuSearch =
    (type: "menu1" | "menu2" | "menu3" | "menu4") =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const target: string = e.target.value;
      setMenuText(target);
      setMenuPagination({
        total: 0,
        lastPage: 1,
        currentPage: 1,
      });
      setShowMenu(type);
    };

  const handleMenuClick = () => {
    setMenuText("");
    setShowMenu(undefined);
  };

  return (
    <div className="p-4">
      <div className="sticky top-[60px] left-0 z-50 bg-white py-4 w-full shadow-md px-2 flex justify-between">
        <h1 className="text-2xl font-bold">Footer Settings</h1>

        <div className="flex gap-4 items-center">
          {/* <button
						className="bg-gray-500 text-white px-4 py-2 rounded-md"
						onClick={handleToDraft}>
						Safe to draft
					</button> */}

          <button
            className="bg-green-500 text-white px-4 py-2 rounded-md"
            onClick={handlePublish}
          >
            Publish
          </button>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        <div className="mt-4 border border-gray-300 px-4 py-1">
                    <p className="text-lg font-semibold">Footer Settings :</p>
                    <SettingFormItems
                        settings={settings}
                        settingItems={footerSettings}
                        onChange={(key, value) => {
                            setSettings((prev) => ({
                                ...prev,
                                [key]: value,
                            }));
                        }}
                    />
                </div>

        <div className="col-span-2 mt-4 border border-gray-300 px-4 py-1">
          <p className="text-lg font-semibold">Footer Menues :</p>

          <div className="flex gap-4 items-center">
            <p>Menu 1 :</p>
            <div className="flex items-center gap-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search Menu..."
                  value={showMenu === "menu1" ? menuText : ""}
                  onChange={handleMenuSearch("menu1")}
                />
                <div className="bg-gray-100 drop-shadow-md shadow-inner rounded">
                  {menues.length > 0 && showMenu === "menu1" && (
                    <div
                      className="pl-3 divide-y max-h-64 min-h-fit overflow-y-scroll no-scrollbar"
                      ref={menuSuggestion}
                      // onScroll={handleMenuScroll}
                    >
                      {menues.map((menu, index) => {
                        return (
                          <div
                            key={index}
                            onClick={() => {
                              handleMenuClick();
                              setMenu1(menu);
                            }}
                          >
                            <div className="flex items-center gap-4 py-2 cursor-pointer">
                              <div className="text-sm font-light tracking-wide truncate">
                                {menu.name}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>

              {menu1 && (
                <div className="p-4 py-2 border border-gray-300 rounded-md shadow-sm">
                  <p>{menu1.name}</p>
                </div>
              )}
            </div>
          </div>

          <div className="flex gap-4 items-center mt-4">
            <p>Menu 2 :</p>
            <div className="flex items-center gap-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search Menu..."
                  value={showMenu === "menu2" ? menuText : ""}
                  onChange={handleMenuSearch("menu2")}
                />
                <div className="bg-gray-100 drop-shadow-md shadow-inner rounded">
                  {menues.length > 0 && showMenu === "menu2" && (
                    <div
                      className="pl-3 divide-y max-h-64 min-h-fit overflow-y-scroll no-scrollbar"
                      ref={menuSuggestion}
                      // onScroll={handleMenuScroll}
                    >
                      {menues.map((menu, index) => {
                        return (
                          <div
                            key={index}
                            onClick={() => {
                              handleMenuClick();
                              setMenu2(menu);
                            }}
                          >
                            <div className="flex items-center gap-4 py-2 cursor-pointer">
                              <div className="text-sm font-light tracking-wide truncate">
                                {menu.name}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>

              {menu2 && (
                <div className="p-4 py-2 border border-gray-300 rounded-md shadow-sm">
                  <p>{menu2.name}</p>
                </div>
              )}
            </div>
          </div>

          <div className="flex gap-4 items-center mt-4">
            <p>Menu 3 :</p>
            <div className="flex items-center gap-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search Menu..."
                  value={showMenu === "menu3" ? menuText : ""}
                  onChange={handleMenuSearch("menu3")}
                />
                <div className="bg-gray-100 drop-shadow-md shadow-inner rounded">
                  {menues.length > 0 && showMenu === "menu3" && (
                    <div
                      className="pl-3 divide-y max-h-64 min-h-fit overflow-y-scroll no-scrollbar"
                      ref={menuSuggestion}
                      // onScroll={handleMenuScroll}
                    >
                      {menues.map((menu, index) => {
                        return (
                          <div
                            key={index}
                            onClick={() => {
                              handleMenuClick();
                              setMenu3(menu);
                            }}
                          >
                            <div className="flex items-center gap-4 py-2 cursor-pointer">
                              <div className="text-sm font-light tracking-wide truncate">
                                {menu.name}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>

              {menu3 && (
                <div className="p-4 py-2 border border-gray-300 rounded-md shadow-sm">
                  <p>{menu3.name}</p>
                </div>
              )}
            </div>
          </div>
          {/* <div className="flex gap-4 items-center mt-4">
            <p>Menu 4 :</p>
            <div className="flex items-center gap-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search Menu..."
                  value={showMenu === "menu4" ? menuText : ""}
                  onChange={handleMenuSearch("menu4")}
                />
                <div className="bg-gray-100 drop-shadow-md shadow-inner rounded">
                  {menues.length > 0 && showMenu === "menu4" && (
                    <div
                      className="pl-3 divide-y max-h-64 min-h-fit overflow-y-scroll no-scrollbar"
                      ref={menuSuggestion}
                      // onScroll={handleMenuScroll}
                    >
                      {menues.map((menu, index) => {
                        return (
                          <div
                            key={index}
                            onClick={() => {
                              handleMenuClick();
                              setMenu4(menu);
                            }}
                          >
                            <div className="flex items-center gap-4 py-2 cursor-pointer">
                              <div className="text-sm font-light tracking-wide truncate">
                                {menu.name}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>

              {menu4 && (
                <div className="p-4 py-2 border border-gray-300 rounded-md shadow-sm">
                  <p>{menu4.name}</p>
                </div>
              )}
            </div>
          </div> */}

          <SettingFormItems
            settings={settings}
            settingItems={footerMenuSettings}
            onChange={(key, value) => {
              setSettings((prev) => ({
                ...prev,
                [key]: value,
              }));
            }}
          />
        </div>
      </div>
    </div>
  );
};



export default FooterMenu;

function createSlug(name: string) {
  return name?.toLowerCase().replace(/ /g, "_");
}
